import { axios } from "../../lib/axios";

export const DeleteMCQ = (quizId: string) => {
    return axios.delete(`/quiz/${quizId}`)
        .then(response => response.data);
};

export const DeleteEssay = (quizId: string) => {
    return axios.delete(`/essay/${quizId}`)
        .then(response => response.data);
};

export const DeleteExam = (quizId: string) => {
    return axios.delete(`/exam/${quizId}`)
        .then(response => response.data);
};